<template>
    <b-row>
        <b-form>
          <h6 class="heading-small text-muted mb-4">Workspace Setup</h6>
          <ValidationObserver ref="validationObserver">

            <ValidationProvider ref="accountProvider" name="Workspace Name" rules="required" v-slot="{ errors }">
              <b-form-group id="account-name-onboard" label-for="account-name-input" description="This could be a company, team or personal name.">
                <b-form-input id="account-name-input" v-model="accountName" type="text" required placeholder="Workspace Name"></b-form-input>
                <b-form-invalid-feedback :state="errors.length === 0">
                  {{errors[0]}}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <hr>

            <ValidationProvider ref="projectProvider" name="Project Name" rules="required" v-slot="{ errors }">
              <b-form-group id="project-name-onboard"  label-for="project-name-input" description="Name your first project! Don't worry, this is your first of many projects...">
                <b-form-input id="project-name-input" v-model="projectName" type="text" required placeholder="Project Name"></b-form-input>
                <b-form-invalid-feedback :state="errors.length === 0">
                  {{errors[0]}}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

          <!-- Another way to do form group -->
          <div class="form-group d-flex align-items-center justify-content-between">
            <span class="text-dark">Email me when jobs complete in this project.</span>
            <base-switch class="mr-1" v-model="emailOn"></base-switch>
          </div>
          </ValidationObserver>
          <b-form-invalid-feedback :state="errorMessage === undefined">
            {{errorMessage}}
          </b-form-invalid-feedback>
        </b-form>
    </b-row>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { AccountCreationRequest } from '#/protobuf/service_account_pb';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      errorMessage: undefined,
      accountName: '',
      projectName: '',
      emailOn: true,
    };
  },
  computed: {
  },
  methods: {
    createAccount() {
      return new Promise((resolve, reject) => {
        this.$refs.validationObserver.validate().then((isValid) => {
          if (!isValid) {
            reject(new Error('validation failed'));
            return;
          }
          console.info('creating  workspace...');
          const req = new AccountCreationRequest();
          req.setAccountName(this.accountName);
          req.setProjectName(this.projectName);
          req.setNotifyType(this.emailOn ? 2 : 0); // TODO: use actual proto NotifyType definition
          this.$store.dispatch('accounts/createAccount', req).then((response) => {
            this.errorMessage = undefined; // set back to undefined in case there was a prior error
            resolve(response);
          }).catch((error) => {
            this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
            reject(new Error(this.errorMessage));
          });
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
